module.exports = __webpack_public_path__ + "static/media/register.1ff9be0e.svg";